import environment from 'environment';
import { LOCAL } from 'constants/envTypes';
import * as AuthServiceModule from '@asurion-core/frontend-utils/lib/AuthService';

export const shareSessionTokenWithAdminDashboard = () => {
  if (environment.app.currentEnv !== LOCAL) {
    return;
  }

  const iframeId = 'local_dev-iframe-for-admin-dashboard';
  let iframe = document.querySelector(`#${iframeId}`);

  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.setAttribute('id', iframeId);
    iframe.setAttribute('src', environment.adminDashboardUrl);
    document.body.appendChild(iframe);
  }

  iframe.onload = () => {
    const dataForTransfer = JSON.stringify({
      [AuthServiceModule.CURRENT_USER_SESSION_DATA_FIELDNAME]: localStorage.getItem(
        AuthServiceModule.CURRENT_USER_SESSION_DATA_FIELDNAME
      ),
    });

    iframe.contentWindow.postMessage(dataForTransfer, '*');
  };
};

export const shareSessionTokenWithExpertDashboard = () => {
  if (environment.app.currentEnv !== LOCAL) {
    return;
  }

  const iframeId = 'local_dev-iframe-for-expert-dashboard';
  let iframe = document.querySelector(`#${iframeId}`);

  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.setAttribute('id', iframeId);
    iframe.setAttribute('src', environment.expertDashboardUrl);
    document.body.appendChild(iframe);
  }

  iframe.onload = () => {
    const dataForTransfer = JSON.stringify({
      [AuthServiceModule.CURRENT_USER_SESSION_DATA_FIELDNAME]: localStorage.getItem(
        AuthServiceModule.CURRENT_USER_SESSION_DATA_FIELDNAME
      ),
    });

    iframe.contentWindow.postMessage(dataForTransfer, '*');
  };
};
